import "./OtpModal.scss"
import { joiResolver } from '@hookform/resolvers/joi'
import { classNames } from 'primereact/utils'
import React from 'react'
import CountDown from 'react-countdown';
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { setUserCredentials } from '../../../../pages/login-page/LoginAuthSlice'
import { selectAllData, setBasicDetails } from '../../../../pages/recruitment/RecruitmentDataSlice'
import { useVerifyEmailCollegeMutation, useVerifyOTPMutation } from '../../../../services/attendance-portal/recruitment/verification'
import PrimaryButton from '../../../../components/prime-react-overrides/button/Button'
import Modal from "../../../../components/prime-react-overrides/modal/Modal"
import PrimeInputText from '../../../../components/prime-react-overrides/input-text/InputText'
import { recruitmentOtpSchema, RECRUITMENT_FORM_KEYS } from './OtpModalData'


const OtpModal = ({ visible, onHide, handleOtpSubmit }) => {
  const dispatch = useDispatch()
  const userState = useSelector(selectAllData)
  const [verifyOtp, { isLoading: OTPloading }] = useVerifyOTPMutation()
  const [verifyDetails, { isLoading: loading }] = useVerifyEmailCollegeMutation()



  const handleResend = async (api) => {
    api.stop();
    api.start();
    const response = await verifyDetails({ "email": userState.personalEmail }).unwrap()
    if (response.emailSent) toast.success(response.message)
  }

  const handleCountdown = ({ completed, seconds, minutes, api }) => {
    if (completed) {
      return <div onClick={() => handleResend(api)} className="ResetCount text-base pb-4 font-bold cursor-pointer">Resend</div>
    }

    return <span className='ResetCount text-base pb-4 font-bold '>Resend Code  <span className='text-white font-normal pl-2'> in {minutes} : {seconds}s</span></span>
  }

  const { control, formState: { errors }, handleSubmit } = useForm({
    resolver: joiResolver(recruitmentOtpSchema),
    defaultValues: {
      [RECRUITMENT_FORM_KEYS.OTP]: ""
    }
  })

  async function handleFormSubmit(e) {
    const { message, user,state } = await verifyOtp({ otp: e.otp, personalEmail: userState.personalEmail }).unwrap()
   

    toast.success(message)

    dispatch(setUserCredentials({ user: { ...user, state} }))
    dispatch(setBasicDetails({ ...userState, isEmailVerified: true,state:state }))


    handleOtpSubmit()

  }
  const header = <h6 className='text-left text-base my-0'>OTP Verification</h6>

  return (
    <Modal
      className='VerifyOtp'
      header={header}
      visible={visible}
      onHide={onHide}
      draggable={false}
      breakpoints={{ "640px": "100vw" }}
      style={{width: '40vw'}}
    >
      <div className='flex flex-column align-items-center justify-content-center'>
        <p className="pb-4">
          OTP is sent to your registered email address.
        </p>
        <form onSubmit={handleSubmit(handleFormSubmit)} className='w-full'>
          <div className="p-fluid field">
            <Controller name={RECRUITMENT_FORM_KEYS.OTP} control={control} render={({ field, fieldState }) => (
              <PrimeInputText id={field[RECRUITMENT_FORM_KEYS.OTP]}
                {...field} className={classNames({ 'p-invalid': fieldState.error }, 'OtpField p-inputtext-lg')}
                placeholder="Enter OTP" />
            )} />

            {errors[RECRUITMENT_FORM_KEYS.OTP] && <small className='ml-3 mt-3 p-error font-medium' >{errors[RECRUITMENT_FORM_KEYS.OTP].message}</small>}
          </div>

          <div className="flex justify-content-center mt-2">
            <CountDown date={Date.now() + (60000 * 2)} renderer={handleCountdown} />
          </div>
          <div className="flex justify-content-center pb-3">
            <PrimaryButton label="VERIFY" className="primaryButton" type='submit' loading={OTPloading} />
          </div>
        </form>

      </div>
    </Modal>

  )
}

export default OtpModal